<template>
  <div id="v-logout-page">
    <div v-if="loading" class="c-loading" style="margin-top: 200px; margin-bottom: 40px;"></div>
    <div v-if="!loading">
      <img src="../assets/logo.png" width="30%" style="padding-top: 6vh; min-width: 300px;"/>
      <h1 style="font-weight: 300; font-size: 4em;">Logged Out</h1>
      <p style="color: #444;">You've been logged out. <router-link to="/">Come back to the home page.</router-link></p>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      loading: true
    }
  },
  created: function () {
    setTimeout(() => {
      this.$firebase.auth().signOut()
      this.loading = false
    }, 1000)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LogoutPage.vue